import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IconGalleryComponent } from "./shared/common-components/icon-gallery/icon-gallery.component";
import { OnboardingComponent } from "./shared/common-components/onboarding/onboarding.component";
import { DesignElementsGalleryComponent } from "./shared/common-components/design-elements-gallery/design-elements-gallery.component";
import { MultiVideoPlayerDemoComponent } from "./shared/common-components/multi-video-player-demo/multi-video-player-demo.component";

import { TermsOfServiceComponent } from "./terms-of-service/terms-of-service.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { HelpCenterComponent } from "./help-center/help-center.component";
import { UserGuideComponent } from "./user-guide/user-guide.component";
import { DairectorOrgInviteAcceptComponent } from "./dairector-org-invite-accept/dairector-org-invite-accept.component";

const routes: Routes = [
  { path: "", redirectTo: "auth", pathMatch: "full" },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "layout",
    loadChildren: () =>
      import("./layout/layout.module").then((m) => m.LayoutModule),
  },
  {
    path: "external",
    loadChildren: () =>
      import("./external/external.module").then((m) => m.ExternalModule),
  },
  {
    path: "onboarding",
    component: OnboardingComponent,
  },
  {
    path: "dairector-org-invite-accept/:invitationlink",
    component: DairectorOrgInviteAcceptComponent,
  },
  // {
  //   path: "workspace-v2/:workspace_id",
  //   loadComponent: () =>
  //     import("./workspace/workspace.component").then((m) => m.WorkspaceComponent),
  // },
  {
    path: "workspace/:workspace_id",
    loadComponent: () =>
      import("./workspace-v2/workspace-v2.component").then(
        (m) => m.WorkspaceV2Component
      ),
  },
  {
    path: "icons",
    component: IconGalleryComponent,
  },
  {
    path: "design-elements",
    component: DesignElementsGalleryComponent,
  },
  {
    path: "multi-video-demo",
    component: MultiVideoPlayerDemoComponent,
  },
  {
    path: "multi-video-demo/:shareId",
    component: MultiVideoPlayerDemoComponent,
  },
  {
    path: "terms-of-service",
    component: TermsOfServiceComponent,
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "help-center",
    component: HelpCenterComponent,
  },
  {
    path: "user-guide",
    component: UserGuideComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
